export function isAnchor(node) {
  return node?.nodeName === 'A';
}
